import api from './api';

export const leadsService = {
  // Get all leads with optional filters
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.status) {
      params.append('status', filters.status);
    }
    if (filters.source) {
      params.append('source', filters.source);
    }
    if (filters.page) {
      params.append('page', filters.page);
    }
    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isIndependentAgent = user.type === 'independent_agent';
    
    const endpoint = isIndependentAgent ? '/independent/leads' : '/leads';
    const response = await api.get(`${endpoint}?${params.toString()}`);
    return response.data;
  },

  // Get single lead by ID
  getById: async (id) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isIndependentAgent = user.type === 'independent_agent';
    
    const endpoint = isIndependentAgent ? `/independent/leads/${id}` : `/leads/${id}`;
    const response = await api.get(endpoint);
    return response.data;
  },

  // Update lead status
  updateStatus: async (id, statusData) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isIndependentAgent = user.type === 'independent_agent';
    
    const endpoint = isIndependentAgent ? `/independent/leads/${id}` : `/leads/${id}/status`;
    const response = await api.put(endpoint, statusData);
    return response.data;
  },

  // Convert lead to quote
  convertToQuote: async (id) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isIndependentAgent = user.type === 'independent_agent';
    
    const endpoint = isIndependentAgent ? `/independent/leads/${id}/convert` : `/leads/${id}/convert`;
    const response = await api.post(endpoint);
    return response.data;
  },

  // Get lead statistics (for dashboard widgets)
  getStats: async () => {
    const response = await api.get('/leads/stats');
    return response.data;
  }
};

export default leadsService;
